







import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class Error extends Vue {
    @Prop({ type: String }) heading!: string;
    @Prop({ type: String }) message!: string;

    private get headingText(): string {
        return this.heading || this.$localize("error.common.title");
    }

    private get messageText(): string {
        return this.message || this.$localize("error.common.message");
    }
}
